exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "th, td {\r\n  padding: 0.3rem;\r\n}\r\n\r\ntable {\r\n  background-color: white;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/terminal-actions-ssbt-report/terminal-actions-ssbt-report-partial/terminal-actions-ssbt-report-partial.component.css
// module id = ../../../../../src/app/terminal-actions-ssbt-report/terminal-actions-ssbt-report-partial/terminal-actions-ssbt-report-partial.component.css
// module chunks = main